import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";

import Alert from "container/Alert.js";

// core components
import Navbar from "componentsCustom/Navbars/Navbar.js";

import Sidebar from "componentsCustom/Sidebar/Sidebar.js";
import SidebarMobile from "view/SidebarMobile.js";
import MobileNavbar from "componentsCustom/Navbars/MobileNavbar.js";
import routesCustom from "routes/routesCustom.js";
import pathSplit from "util/pathSplit";
import styles from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.js";
import "assets/scss/custom/calendar.css";

import { calculateAllCart } from "util/calculation.js";
import getMuseum from "api/getMuseum";
import getEventi from "api/getEventi";

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const {
    cart,
    language,
    updateMuseum,
    currency,
    museum,
    customStyle,
    shippingInfo,
    updateCartParams,
    cartParams,
    updateLanguage,
    promotionalCode,
    updateEvents,
    updateArticles,
    updateCustomStyle,
  } = props;

  const { t, i18n } = useTranslation();

  const rootDiv = document.getElementById("root");
  // const routesNameCustom = rootDiv.getAttribute("routesNameCustom");
  const routesNameCustom = "emma-shopping";

  const languageCustom = rootDiv.getAttribute("languageCustom");

  let location = useLocation();

  let routes = routesCustom(routesNameCustom);

  // disp = dispatch;
  // states and functions
  const [isMobile, setIsMobile] = useState(window.innerWidth < 960);

  const [logo, setLogo] = useState("");
  const [logoText, setLogoText] = useState("");
  const [, setOpenings] = useState({});
  const [webLink] = useState("");
  const [showCartSideBar, setShowCartSideBar] = useState(false);

  const toggleCartSideBar = () => {
    setShowCartSideBar((val) => !val);
  };

  const resizeFunction = () => {
    if (window.innerWidth < 960) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    if (languageCustom && languageCustom !== "it") {
      i18n.changeLanguage(languageCustom);
      updateLanguage(languageCustom);
    }

    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      window.removeEventListener("resize", resizeFunction);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { id } = pathSplit(
      location && location.pathname ? location.pathname : "",
      ""
    );

    // const museumId = rootDiv.getAttribute("museumId");
    const museumId = id;

    getMuseum(museumId).then((response) => {
      if (
        response &&
        response.articles &&
        response.articles[0] &&
        response.museo
      ) {
        const museo = Object.assign({}, response.museo, {
          organisation: response.organization,
        });
        updateMuseum(museo);

        const articles = response.articles;
        updateArticles(articles);
        let logoC = "";
        if (museo && museo.logo_light && museo.logo_light.url) {
          logoC = museo.logo_light.url;
          setLogo(museo.logo_light.url);
        }
        if (museo && museo.orari_museo) {
          setOpenings(museo.orari_museo);
        }
        if (museo && museo.colore) {
          const obj = Object.assign({}, customStyle, {
            // buttonAction: museo.colore,
            // buttonContinue: museo.colore,
            // buttonCart: museo.colore,
            buttonAction: "#303030",
            buttonContinue: "#303030",
            buttonCart: "#303030",
            museoColor: museo.colore,
            logo: logo || logoC || require("assets/img/logo.png"),
          });
          updateCustomStyle(obj);
        }

        // if (response && customStyle) {
        //   updateCustomStyle(
        //     Object.assign(
        //       {},
        //       response.delivery.customStyle,
        //       logoC ? { logo: logoC } : {}
        //     )
        //   );
        // }
        if (museo && museo.nome) {
          setLogoText(museo.nome);
        }
        // else if (
        //   response &&
        //   response.reservationData &&
        //   response.reservationData.delivery
        // ) {
        //   // ONLY TYPE IS RESERVATION
        //   const copyShippingInfo = Object.assign({}, shippingInfo, {
        //     city: "",
        //     cap: "",
        //     polygonId: "",
        //     type: "Reservation"
        //   });
        //   updateShippingInfo(copyShippingInfo);
        // }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { id } = pathSplit(
      location && location.pathname ? location.pathname : "",
      ""
    );

    // const museumId = rootDiv.getAttribute("museumId");
    const museumId = id;

    getMuseum(museumId).then((response) => {
      if (
        response &&
        response.articles &&
        response.articles[0] &&
        response.museo
      ) {
        const museo = Object.assign({}, response.museo, {
          organisation: response.organization,
        });
        getEventi(museo.organisation.id).then((response) => {
          updateEvents(response);
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [miniActive, setMiniActive] = useState(false);
  const [
    color,
    // setColor
  ] = useState("blue");
  // const [bgColor, setBgColor] = useState("white");
  // const [hasImage, setHasImage] = useState(true);

  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount

  useEffect(() => {
    const {
      totalPrice,
      servicesFees,
      deliveryCost,
      total,
      cartCounter,
      totToShow,
      vat,
      discount,
      // EURO FOR PAYMENT
      totalPriceEuro,
      servicesFeesEuro,
      deliveryCostEuro,
      totalEuro,
      totToShowEuro,
      vatEuro,
      discountEuro,
    } = calculateAllCart(
      cart,
      currency,
      museum.delivery,
      shippingInfo,
      promotionalCode,
      museum && museum.reservationData ? museum.reservationData : null
    );

    updateCartParams({
      totalPrice,
      servicesFees,
      deliveryCost,
      total,
      cartCounter,
      totToShow,
      vat,
      discount,
      // EURO FOR PAYMENT
      totalPriceEuro,
      servicesFeesEuro,
      deliveryCostEuro,
      totalEuro,
      totToShowEuro,
      vatEuro,
      discountEuro,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart, shippingInfo, museum, currency, promotionalCode]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // const getActiveRoute = routes => {
  //   let activeRoute = "";
  //   for (let i = 0; i < routes.length; i++) {
  //     if (routes[i].collapse) {
  //       let collapseActiveRoute = getActiveRoute(routes[i].views);
  //       if (collapseActiveRoute !== activeRoute) {
  //         return collapseActiveRoute;
  //       }
  //     } else {
  //       console.log("PPPPP", { l: routes[i].name, i, routes });
  //       if (
  //         window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
  //       ) {
  //         return routes[i].name;
  //       }
  //     }
  //   }
  //   return activeRoute;
  // };

  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };

  const getRoutes = (routes) => {
    return routes.map((prop) => {
      if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.pathTo} key={prop.id} />;
      }
      return (
        <Route
          component={prop.component}
          key={prop.id}
          path={`${prop.layout}${prop.path}`}
        >
          {/* {prop.component} */}
        </Route>
      );
    });
  };

  return (
    <div
      className={classes.wrapper}
      style={
        isMobile
          ? {
              backgroundColor: "white",
            }
          : {}
      }
    >
      <div className={mainPanelClasses} ref={mainPanel}>
        {/* ******* WEB >= 960 ********** */}
        <Hidden smDown implementation="css">
          <Navbar
            sidebarMinimize={sidebarMinimize.bind(this)}
            miniActive={miniActive}
            // brandText={getActiveRoute(routes)}
            brandText=""
            handleDrawerToggle={handleDrawerToggle}
            cart={cart}
            currency={currency}
            museum={museum}
            customStyle={customStyle}
            shippingInfo={shippingInfo}
            cartParams={cartParams}
            toggleCartSideBar={toggleCartSideBar}
          />{" "}
        </Hidden>
        {/* ******* MOBILE < 960 ********** */}
        <Hidden mdUp implementation="css">
          <MobileNavbar
            brandText={""}
            handleDrawerToggle={handleDrawerToggle}
            cart={cart}
            logo={logo}
            webLink={webLink}
            customStyle={customStyle}
          />{" "}
        </Hidden>

        <div className={classes.content}>
          {mobileOpen && isMobile ? null : <Switch>{getRoutes(routes)}</Switch>}
        </div>
        <Alert />
        {mobileOpen && isMobile && (
          <SidebarMobile
            cart={cart}
            language={language}
            handleDrawerToggle={handleDrawerToggle}
            currency={currency}
            logo={logo}
            webLink={webLink}
            museum={museum}
            customStyle={customStyle}
            shippingInfo={shippingInfo}
            cartParams={cartParams}
          />
        )}
      </div>
      <Sidebar
        routes={routes}
        logoText={logoText}
        logo={logo}
        webLink={webLink}
        image={undefined}
        // handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        bgColor={"white"}
        miniActive={miniActive}
        t={t}
        cartCounter={cartParams.cartCounter}
        customStyle={customStyle}
        showCartSideBar={showCartSideBar}
        rtlActive
        closeCartSideBar={toggleCartSideBar}
      />
    </div>
  );
}

Dashboard.propTypes = {
  updateCart: PropTypes.func.isRequired,
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    timetable: PropTypes.object,
    date: PropTypes.any,
  }).isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
  museum: PropTypes.object.isRequired,
  updateMuseum: PropTypes.func.isRequired,
  events: PropTypes.array.isRequired,
  updateEvents: PropTypes.func.isRequired,
  cart: PropTypes.arrayOf(PropTypes.object),
  language: PropTypes.string.isRequired,
  rtlActive: PropTypes.bool,
  customStyle: PropTypes.object,
  updateCartParams: PropTypes.func.isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number,
  }).isRequired,
  promotionalCode: PropTypes.shape({
    _id: PropTypes.string,
    measure: PropTypes.string,
    active: PropTypes.bool,
    minCost: PropTypes.number,
    from: PropTypes.string,
    to: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.number,
    museumId: PropTypes.string,
    timeLimitEnabled: PropTypes.bool,
  }).isRequired,
  updatePromotionalCode: PropTypes.func.isRequired,
  updateLanguage: PropTypes.func.isRequired,
  updateCustomStyle: PropTypes.func.isRequired,
  updateArticles: PropTypes.func.isRequired,
};

Dashboard.defaultProps = {
  rtlActive: false,
  customStyle: {},
};
